import styles from './style.postcss';

import React, { Component } from 'react';
import ViewNavButton from '../ViewNavButton';
import ViewNavExtra from '../ViewNavExtra';
import { DropdownBox, Button, testClass, Icon } from 'omni-common-ui';
import classnames from 'classnames';
import PropTypes from 'prop-types';

class ViewNavSmall extends Component {
  constructor(props) {
    super(props);
    this.state = { open: false };
    this._setUp(props);
  }

  componentWillUpdate(props) {
    this._setUp(props);
  }

  _setUp(props) {
    const childrenArr = React.Children.toArray(props.children);
    this._buttons = childrenArr.filter((child) => child.type === ViewNavButton);
    this._extra = childrenArr.find((child) => child.type === ViewNavExtra);
  }

  _toggleDropdown(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    this.setState({ open: ! this.state.open });
  }

  _renderDropdown() {
    if (this._buttons.length <= 0) {
      return <div />;
    }

    return <DropdownBox.Container className={styles.ViewNavSmall_container}
        onClickOutside={() => this.setState({ open: false })}>
      <div className={classnames(styles.ViewNavSmall_expand, testClass('viewnav-expand-action-buttons'))}
          onClick={(e) => this._toggleDropdown(e)}>
        <Icon id="dots" />
      </div>
      <DropdownBox className={classnames(styles.ViewNavSmall_dropdown, testClass('viewnav-action-buttons'))}
          open={this.state.open}>
        {
          this._buttons.map(({ props }) => <DropdownBox.Item className={styles.ViewNavSmall_item}>
            <Button {...props}
                className={classnames(styles.ViewNavSmall_item_button, props.className)}>
              {props.title}
            </Button>
          </DropdownBox.Item>)
        }
      </DropdownBox>
    </DropdownBox.Container>;
  }

  render() {
    return <div className={styles.ViewNavSmall}>
      {this._renderDropdown()}
      {this._extra}
    </div>;
  }
}

ViewNavSmall.propTypes = {
  children: PropTypes.arrayOf(ViewNavButton),
};

export default ViewNavSmall;



// WEBPACK FOOTER //
// ./containers/Group/MidtermAndFinalExamHFv4/ViewNavHFv4/ViewNavSmall/index.jsx